import Jsona from 'jsona';

const dataFormatter = new Jsona();

const deserialize = (data: any) => {
    return dataFormatter.deserialize(data);
};

export default deserialize;
